<template>
  <div id="system-journal-setting-language-setting">
    <div class="panel">
      <ipub-button type="primary" icon="iconAdd" @click="add">
        Add New Language
      </ipub-button>
    </div>

    <ipub-table
      :columns="columns"
      fixed
      :pagination="false"
      :dataSource="dataSource"
    >
      <template v-slot:language="row">
        {{ row.record.language }}
      </template>
      <template v-slot:summary="row">
        {{ row.record.languagePack ? row.record.languagePack.summary : '' }}
      </template>
      <template v-slot:keyword="row">
        {{ row.record.languagePack ? row.record.languagePack.keyword : '' }}
      </template>
      <template v-slot:keywords="row">
        {{ row.record.languagePack ? row.record.languagePack.keywords : '' }}
      </template>
      <template v-slot:reference="row">
        {{ row.record.languagePack ? row.record.languagePack.reference : '' }}
      </template>
      <template v-slot:references="row">
        {{ row.record.languagePack ? row.record.languagePack.references : '' }}
      </template>
      <template v-slot:actions="{ record }">
        <ipub-tooltip class="border-right">
          <div slot="title">Edit</div>
          <ipub-icon type="iconEdit" @click="edit(record)" />
        </ipub-tooltip>
        <ipub-tooltip>
          <div slot="title">Delete</div>
          <ipub-icon type="iconDelete" @click="del(record)" />
        </ipub-tooltip>
      </template>
    </ipub-table>
    <add-dialog
      :isVisible="isVisible"
      :inputData="inputData"
      @cancel="cancel"
      @confirm="confirmType"
    ></add-dialog>
  </div>
</template>

<script>
import addDialog from '@/views/system/journal-setting/language-setting/add.dialog.vue'
import { settingJournalLanguage } from '@/api/setting'
import { mapGetters } from 'vuex'

const columns = [
  {
    title: '',
    enTitle: 'language',
    width: 200,
    dataIndex: 'language',
    slot: 'language',
  },
  {
    title: '',
    enTitle: 'Summary',
    width: 200,
    dataIndex: 'summary',
    slot: 'summary',
  },
  {
    title: '',
    enTitle: 'Keyword',
    width: 180,
    dataIndex: 'keyword',
    slot: 'keyword',
  },
  {
    title: '',
    enTitle: 'Keywords',
    width: 120,
    dataIndex: 'keywords',
    slot: 'keywords',
  },
  {
    title: '',
    enTitle: 'Reference',
    width: 200,
    dataIndex: 'reference',
    slot: 'reference',
  },
  {
    title: '',
    enTitle: 'References',
    width: 200,
    dataIndex: 'references',
    slot: 'references',
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 120,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions',
  },
]

export default {
  components: { addDialog },
  data() {
    return {
      isVisible: false,
      inputData: {},
      dataSource: [],
      columns,
      query: {
        journalId: '',
      },
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      journalId: 'getJournalId',
      publisherId: 'getPublisherId',
    }),
  },
  watch: {
    journalId: {
      handler() {
        this.getTableData()
      },
      immediate: true,
    },
  },
  mounted() {
    this.getTableData()
  },
  methods: {
    async getTableData() {
      this.query.journalId = this.journalId
      this.dataSource = await settingJournalLanguage.getAll(this.query)
    },
    add() {
      this.isVisible = true
      this.inputData = {}
    },
    cancel() {
      this.isVisible = false
      this.inputData = {}
    },
    confirmType() {
      this.isVisible = false
      this.getTableData()
    },
    edit(record) {
      this.inputData = record
      this.isVisible = true
    },
    del(record) {
      this.$confirm({
        title: 'Are you sure you want to delete this language ?',
        content:
          'Please be aware of once this language is deleted, it will never be able to recovered.',
        type: 'danger',
        icon: 'iconDelete',
      }).then(async () => {
        settingJournalLanguage.del(record.id).then(async () => {
          await this.getTableData()
          this.$message.success({
            title: 'Success',
            content: 'This Language has been deleted!',
          })
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
#system-journal-setting-language-setting {
  .panel {
    display: flex;
    justify-content: end;
  }
}
</style>
